import React, { useState, useEffect } from 'react'
import Link from '../Link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import useWindowSize from '../../hooks/useWindowSize'

import ArrowRight from '../../../assets/images/ArrowRight.svg'

import {
  fourAcrossSquaresOuterContainer,
  fourAcrossSquaresInnerContainer,
  fourAcrossSquaresColumnContainer,
  fourAcrossSquaresHeadingContainer,
  fourAcrossSquaresColumn,
  fourAcrossSquaresDark,
  fourAcrossSquaresTextContainer,
  fourAcrossSquaresImageContainer,
  fourAcrossSquaresNormalImageContainer,
  fourAcrossSquaresCtaLinkArrow,
} from './index.module.css'

import { isSvgOrGif } from '../../utils'

const FourAcrossSquares = ({
  title,
  components,
  isDarkTheme,
  hideTitle,
  backgroundColor,
}) => {
  const defaultBackgroundColor = isDarkTheme ? '#000000' : '#FFFFFF'
  const size = useWindowSize()
  const [isTablet, setIsTablet] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const LinkWrapper = ({ url, children }) => {
    return url ? <Link to={url}>{children}</Link> : children
  }

  useEffect(() => {
    setIsTablet(size.width <= 1439 && size.width >= 510)
    setIsMobile(size.width <= 510)
  }, [size.width])

  return (
    <div
      className={[isDarkTheme ? fourAcrossSquaresDark : ''].join(' ')}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={['wrapper', fourAcrossSquaresOuterContainer].join(' ')}>
        <div
          className={['container', fourAcrossSquaresInnerContainer].join(' ')}
        >
          {(hideTitle === null || hideTitle === false) && (
            <div className={fourAcrossSquaresHeadingContainer}>
              <h2>{title}</h2>
            </div>
          )}

          <div
            className={fourAcrossSquaresColumnContainer}
            style={{
              gridTemplateRows:
                isTablet && components.length <= 2
                  ? '1fr'
                  : isMobile
                  ? '1fr'
                  : '1fr 1fr',
            }}
          >
            {components &&
              components.map(({ ctaText, ctaUrl, title, image }, index) => {
                return (
                  <div className={fourAcrossSquaresColumn} key={index}>
                    {image &&
                      (isSvgOrGif(image.file.url) ? (
                        <div
                          className={[
                            fourAcrossSquaresImageContainer,
                            fourAcrossSquaresNormalImageContainer,
                          ].join(' ')}
                        >
                          <Link to={ctaUrl}>
                            <img
                              alt={image.description}
                              src={image.file.url}
                              style={{
                                objectFit: 'contain',
                                height:
                                  image.file.details.image.height >
                                  image.file.details.image.width
                                    ? '100%'
                                    : '',
                              }}
                            />
                          </Link>
                        </div>
                      ) : (
                        <div className={fourAcrossSquaresImageContainer}>
                          <Link to={ctaUrl}>
                            <GatsbyImage
                              alt={image.description}
                              image={getImage(image.fourAcrossSquaresImage)}
                              objectFit="contain"
                            />
                          </Link>
                        </div>
                      ))}
                    <div className={fourAcrossSquaresTextContainer}>
                      {title && (
                        <h3>
                          {<LinkWrapper url={ctaUrl}>{title}</LinkWrapper>}
                        </h3>
                      )}
                      {ctaText && ctaUrl && (
                        <Link to={ctaUrl}>
                          {ctaText}
                          <ArrowRight
                            className={fourAcrossSquaresCtaLinkArrow}
                          />
                        </Link>
                      )}
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FourAcrossSquares
